import * as type from './FormsType';
const initialState = {
    forms: null
};

export const formsReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_PATIENT_FORMS:
            return { ...state, forms: action.payload };
        case type.ADD_PATIENT_FORM:
            return {
                ...state,
                forms: [action.payload, ...state.forms]
            };
        case type.REPLACE_PATIENT_FORM: {
            const newForm = action.payload;
            const newFormsList = state.forms.map((val) => {
                if (val.id === newForm.id) {
                    return newForm;
                } else {
                    return val;
                }
            });
            return {
                ...state,
                forms: newFormsList
            };
        }
        case type.REMOVE_PATIENT_FORM: {
            const prevForms = state.forms.filter((val) => val.id !== action.payload);
            return {
                ...state,
                forms: prevForms
            };
        }
        default:
            return state;
    }
};
